"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_fetch_api_1 = require("@giphy/js-fetch-api");
var bricks_js_1 = __importDefault(require("bricks.js"));
var css_1 = require("@emotion/css");
var preact_1 = require("preact");
var throttle_debounce_1 = require("throttle-debounce");
var observer_1 = __importDefault(require("../util/observer"));
var fetch_error_1 = __importDefault(require("./fetch-error"));
var gif_1 = __importDefault(require("./gif"));
var loader_1 = __importDefault(require("./loader"));
var pingback_context_manager_1 = __importDefault(require("./pingback-context-manager"));
var loaderHiddenCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    opacity: 0;\n"], ["\n    opacity: 0;\n"])));
var defaultProps = Object.freeze({ gutter: 6, user: {} });
var initialState = Object.freeze({
    isFetching: false,
    isError: false,
    numberOfGifs: 0,
    gifWidth: 0,
    gifs: [],
    isLoaderVisible: true,
    isDoneFetching: false,
});
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.el = null;
        _this.paginator = (0, js_fetch_api_1.gifPaginator)(_this.props.fetchGifs);
        _this.onLoaderVisible = function (isVisible) {
            _this.setState({ isLoaderVisible: isVisible }, _this.onFetch);
        };
        _this.fetchGifs = (0, throttle_debounce_1.debounce)(Grid.fetchDebounce, function (prefetchCount) { return __awaiter(_this, void 0, void 0, function () {
            var gifs, error_1, onGifsFetchError, onGifsFetched;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.paginator()];
                    case 1:
                        gifs = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        this.setState({ isFetching: false, isError: true });
                        onGifsFetchError = this.props.onGifsFetchError;
                        if (onGifsFetchError)
                            onGifsFetchError(error_1);
                        return [3 /*break*/, 3];
                    case 3:
                        if (gifs) {
                            // if we've just fetched and we don't have
                            // any more gifs, we're done fetching
                            if (prefetchCount === gifs.length) {
                                this.setState({ isDoneFetching: true });
                            }
                            else {
                                this.setState({ gifs: gifs, isFetching: false });
                                onGifsFetched = this.props.onGifsFetched;
                                if (onGifsFetched)
                                    onGifsFetched(gifs);
                                this.onFetch();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        _this.onFetch = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, isFetching, isLoaderVisible, gifs;
            return __generator(this, function (_b) {
                _a = this.state, isFetching = _a.isFetching, isLoaderVisible = _a.isLoaderVisible, gifs = _a.gifs;
                if (!isFetching && isLoaderVisible) {
                    this.setState({ isFetching: true, isError: false });
                    this.fetchGifs(gifs.length);
                }
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    Grid.getDerivedStateFromProps = function (_a, prevState) {
        var columns = _a.columns, gutter = _a.gutter, width = _a.width;
        var gutterOffset = gutter * (columns - 1);
        var gifWidth = Math.floor((width - gutterOffset) / columns);
        if (prevState.gifWidth !== gifWidth) {
            return { gifWidth: gifWidth };
        }
        return {};
    };
    Grid.prototype.setBricks = function () {
        var _a = this.props, columns = _a.columns, gutter = _a.gutter;
        // bricks
        this.bricks = (0, bricks_js_1.default)({
            container: this.el,
            packed: "data-packed-".concat(columns),
            sizes: [{ columns: columns, gutter: gutter }],
        });
    };
    Grid.prototype.componentDidMount = function () {
        this.setBricks();
        this.onFetch();
    };
    Grid.prototype.componentDidUpdate = function (prevProps, prevState) {
        var gifs = this.state.gifs;
        var gifWidth = this.state.gifWidth;
        var numberOfOldGifs = prevState.gifs.length;
        var numberOfNewGifs = gifs.length;
        if (prevState.gifWidth !== gifWidth && numberOfOldGifs > 0) {
            var columns = this.props.columns;
            if (columns !== prevProps.columns) {
                this.setBricks();
            }
            this.bricks.pack();
        }
        if (prevState.gifs !== gifs) {
            if (numberOfNewGifs > numberOfOldGifs && numberOfOldGifs > 0) {
                // we just added new gifs
                this.bricks.update();
            }
            else {
                // we changed existing gifs or removed a gif
                this.bricks.pack();
            }
        }
    };
    Grid.prototype.render = function (_a, _b) {
        var _this = this;
        var onGifVisible = _a.onGifVisible, onGifRightClick = _a.onGifRightClick, _c = _a.className, className = _c === void 0 ? Grid.className : _c, onGifClick = _a.onGifClick, onGifHover = _a.onGifHover, onGifKeyPress = _a.onGifKeyPress, onGifSeen = _a.onGifSeen, user = _a.user, noResultsMessage = _a.noResultsMessage, hideAttribution = _a.hideAttribution, noLink = _a.noLink, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d, borderRadius = _a.borderRadius;
        var gifWidth = _b.gifWidth, gifs = _b.gifs, isError = _b.isError, isDoneFetching = _b.isDoneFetching;
        var showLoader = !isDoneFetching;
        var isFirstLoad = gifs.length === 0;
        return ((0, preact_1.h)(pingback_context_manager_1.default, { attributes: { layout_type: 'GRID' } },
            (0, preact_1.h)("div", { class: className },
                (0, preact_1.h)("div", { ref: function (c) { return (_this.el = c); } },
                    gifs.map(function (gif) { return ((0, preact_1.h)(gif_1.default, { gif: gif, key: gif.id, tabIndex: tabIndex, width: gifWidth, onGifClick: onGifClick, onGifHover: onGifHover, onGifKeyPress: onGifKeyPress, onGifSeen: onGifSeen, onGifVisible: onGifVisible, onGifRightClick: onGifRightClick, user: user, hideAttribution: hideAttribution, noLink: noLink, borderRadius: borderRadius })); }),
                    !showLoader && gifs.length === 0 && noResultsMessage),
                isError ? ((0, preact_1.h)(fetch_error_1.default, { onClick: this.onFetch })) : (showLoader && ((0, preact_1.h)(observer_1.default, { onVisibleChange: this.onLoaderVisible },
                    (0, preact_1.h)(loader_1.default, { className: (0, css_1.cx)(Grid.loaderClassName, isFirstLoad ? loaderHiddenCss : '') })))))));
    };
    Grid.className = 'giphy-grid';
    Grid.loaderClassName = 'giphy-loader';
    Grid.defaultProps = defaultProps;
    Grid.fetchDebounce = 250;
    return Grid;
}(preact_1.Component));
exports.default = Grid;
var templateObject_1;
//# sourceMappingURL=grid.js.map